import "./InputField.scss";
import React, { useEffect, useState } from "react";
import TextBoxControl from "../TextBoxControl";
import { useValidationManager } from "../../../hooks/useValidation";

export function ChipInputField({
  value,
  fieldName,
  validationName,
  title,
  info,
  placeholder,
  onChange,
  validateOnBlur,
  forceValidate,
  onUpdate,
  groupId,
  isDisabled,
  className,
  customValidate,
  currentData,
  delimiter = ",",
}) {
  const [chips, setChips] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [validationErrors, setValidationErrors] = useState([]);
  const validationMgr = useValidationManager(forceValidate, groupId);

  useEffect(() => {
    setChips(value?.length > 0 ? value : []);
  }, [value]);

  const updatedValidationName =
    validationName?.toLowerCase() ?? `${groupId}_${fieldName}`.toLowerCase();
  const isRequired =
    validationMgr?.getConfig(updatedValidationName)?.isRequired &&
    validationMgr?.getConfig(updatedValidationName)?.groupId === groupId;

  const handleValidate = (currentValue) => {
    let validationResult = null;
    if (validateOnBlur || forceValidate) {
      if (!customValidate) {
        validationResult = validationMgr.runValidation(
          currentValue,
          updatedValidationName,
          currentData
        );
      } else {
        validationResult = customValidate(currentValue, currentData);
      }
      setValidationErrors(validationResult.messages);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === delimiter) {
      e.preventDefault();
      const newValue = inputValue.trim();

      if (newValue) {
        // Split the input value by the delimiter and filter out empty strings
        const newValues = newValue
          .split(delimiter)
          .map((v) => v.trim())
          .filter((v) => v.length > 0);

        // Add all new values to existing chips
        const updatedChips = [...chips, ...newValues];
        setChips(updatedChips);
        setInputValue("");

        if (onChange) {
          onChange(updatedChips.join(delimiter), fieldName);
        }

        if (validateOnBlur || forceValidate) {
          handleValidate(updatedChips.join(delimiter));
        }
      }
    } else if (e.key === "Backspace" && !inputValue && chips.length > 0) {
      const updatedChips = chips.slice(0, -1);
      setChips(updatedChips);

      if (onChange) {
        onChange(updatedChips.join(delimiter), fieldName);
      }
    }
  };

  const removeChip = (index) => {
    const updatedChips = chips.filter((_, i) => i !== index);
    setChips(updatedChips);

    if (onChange) {
      onChange(updatedChips.join(delimiter), fieldName);
    }
  };

  const handleOnChange = (currentValue) => {
    setInputValue(currentValue);
    console.log("ChipInputField.handleOnChange");
  };

  const onBlur = (e) => {
    if (validateOnBlur) {
      handleValidate(e.target.value);
    }

    if (onUpdate) {
      onUpdate(e.target.value, fieldName);
    }
  };

  return (
    <div className="field-input">
      <div className={`generic-input-component`} field-name={fieldName}>
        <div className="title-header">
          {title && (
            <div className={`title`}>
              <div>
                {title}
                {isRequired ? "*" : ""}
              </div>
              <div>{info}</div>
            </div>
          )}
        </div>
        <div className={`input-wrapper ${className ?? ""}`}>
          <div className="chips-container">
            {chips.map((chip, index) => (
              <span key={index} className="chip">
                {chip}
                <span className="chip-remove" onClick={() => removeChip(index)}>
                  ×
                </span>
              </span>
            ))}
            <TextBoxControl
              disabled={isDisabled}
              field={{
                PlaceHolder: placeholder,
                FieldName: fieldName,
              }}
              error={validationErrors.length > 0 ? "true" : "false"}
              onBlur={onBlur}
              value={inputValue}
              onChange={(e) => handleOnChange(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>
        </div>
      </div>
      <div className={"error-wrapper"}>
        {validationErrors.map((message) => (
          <span key={message} className={"error"}>
            {message}&nbsp;
          </span>
        ))}
      </div>
    </div>
  );
}
